<template>
  <div class="pop_enterApp popup_wrap" style="display:block">
    <div class="popup_in">
      <!-- Mobile banner -->
      <!-- <div v-if="step == 'after-login' && isMobile">
        <a href="https://u.hmc.co.il/lgl4" target="_blank">
          <div class="">
            <a
              class="blacken"
              href="javascript:void(0);"
              @click="$emit('close')"
            >
              <CloseBlue />
            </a>
          </div>
          <img src="../../assets/img/layout/welcome.png" alt="" />
        </a>
      </div> -->
      <!-- Desktop banner -->
      <!-- <div v-else-if="step == 'after-login' && !isMobile">
        <a href="https://u.hmc.co.il/lgl4" target="_blank">
          <div class="close-wrapper">
            <a
              class="desktop-close"
              href="javascript:void(0);"
              @click="$emit('close')"
            >
              <CloseBlue />
            </a>
          </div>
          <img src="../../assets/img/layout/welcome-desktop.png" alt="" />
        </a>
      </div> -->
      <div class="popup">
        <div class="popup_close_blue">
          <a href="javascript:void(0);" @click="$emit('close')">
            <CloseBlue />
          </a>
        </div>
        <div class="pop_enterApp-head bg--white">
          <logoMedical />
        </div>
        <!-- Desktop QR-->
        <div
          v-show="step == 'init-desktop'"
          class="pop_enterApp-bottom tx--white"
        >
          <div class="title tx--white">
            היי דוקטורס,
            <br />
            כל מה שצריך במקום אחד
            <b class="bold block">עכשיו גם מהנייד</b>
          </div>
          <div class="text--28 ft--400">סרקו והורידו</div>
          <img class="QR" src="../../assets/img/layout/QR.png" />
          <a
            class="no_qr_link text ft--400"
            href="javascript:void(0);"
            @click="$emit('close')"
          >
            המשך לאתר
          </a>
        </div>
        <!-- Mobile -->
        <div
          v-show="step == 'init-mobile'"
          class="pop_enterApp-bottom tx--white"
        >
          <div class="title tx--white">
            היי דוקטורס,
            <br />
            כל מה שצריך במקום אחד
            <b class="bold m-block">עכשיו גם מהנייד</b>
          </div>
          <div class="text--28 ft--400">להורדת האפלקציה</div>
          <div class="hold-app-store flex flex--content--center">
            <a
              href="https://play.google.com/store/apps/details?id=com.hmczimun.hmcappliction"
              target="_blank"
            >
              <img src="assets/img/svg/google-play.svg" alt="" />
            </a>
            <a
              href="https://apps.apple.com/il/app/mymedical-doctors/id1619098479"
              target="_blank"
            >
              <!-- href="https://apps.apple.com/app/idcom.hmczimun.hmcappliction" -->
              <!-- https://onelink.to/a59xnr -->
              <img src="assets/img/svg/app-store1.svg" alt="" />
            </a>
          </div>
          <div class="text--28">או</div>
          <a
            class="text--28 tx--under ft--400 tx--white block"
            style="margin-top:5px"
            href="javascript:void(0);"
            @click="$emit('close')"
          >
            לגלישה באתר מותאם
          </a>
        </div>
        <!-- After login -->
        <div
          v-if="step == 'after-login' && !isMobile"
          class="pop_enterApp-bottom tx--white"
        >
          <div class="title title--55 bold no-marge tx--white">
            ברוכ/ה הבא/ה
          </div>
          <div class="title tx--white">לאפליקצית מיי מדיקל doctors</div>
          <div class="text--28 tx--white">כל מה שאתם צריכים במקום אחד</div>
          <a
            class="bt-white"
            href="javascript:void(0);"
            @click="$emit('close')"
          >
            הבנתי, קח אותי פנימה
          </a>
        </div>
      </div>
    </div>
    <!-- <div class="bgblack"></div> -->
  </div>
</template>

<script>
import CloseBlue from "../../assets/img/svg/close-blue.svg";
import logoMedical from "../../assets/img/svg/logo-myMedical.svg";

export default {
  name: "EnterPop",
  components: { CloseBlue, logoMedical },
  data() {
    return {
      isMobile: false
    };
  },
  mounted() {
    this.isMobile = window.innerWidth < 1200;
  },
  props: {
    step: {
      required: true,
      type: String
    }
  }
};
</script>

<style scoped>
.blacken svg {
  position: relative;
  right: 25px;
  top: 60px;
}
.blacken svg path {
  fill: black;
}
.close-wrapper {
  height: 1px;
}
.desktop-close svg {
  position: relative;
  right: 38px;
  top: 35px;
}
.desktop-close svg path {
  fill: transparent;
}
</style>
